import React, { createContext, useEffect, useState, useRef } from 'react';
import axiosInstance from '../Requests/axios'; // Adjust the path as necessary

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);

  const userDataRequestInitRef = useRef(null);
  useEffect(() => {
    if (!userDataRequestInitRef.current) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      userDataRequestInitRef.current = true;
      axiosInstance.get('/auth/me')
        .then(response => {
          setUserData(response.data);
        })
        .catch(error => {
          setUserData({});
          console.error('There was an error fetching the user data:', error);
        });
    }
  }, []);

  return (
    <UserContext.Provider value={{ userData }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
